/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

/**
 * Generated types for CHIRP model: com.hubspot.breeze.engine.shared.models.citation.Citation
 *
 * [View Java Source](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+Citation)
 */

export const CITATION_MODEL_FINGERPRINT = '48R9brBUKJ0=';
export const AppCitationTypename = 'com.hubspot.breeze.engine.shared.models.citation.AppCitation';
export const AppCitationDiscriminant = 'AppCitation';
export const AppCitationDiscriminantKey = '_type';
export const CitationDiscriminantKey = '_type';
export const CrmObjectCitationTypename = 'com.hubspot.breeze.engine.shared.models.citation.CrmObjectCitation';
export const CrmObjectCitationDiscriminant = 'CrmObjectCitation';
export const CrmObjectCitationDiscriminantKey = '_type';
export const RichContentCitationTypename = 'com.hubspot.breeze.engine.shared.models.citation.RichContentCitation';
export const RichContentCitationDiscriminant = 'RichContentCitation';
export const RichContentCitationDiscriminantKey = '_type';
export const WebPageCitationTypename = 'com.hubspot.breeze.engine.shared.models.citation.WebPageCitation';
export const WebPageCitationDiscriminant = 'WebPageCitation';
export const WebPageCitationDiscriminantKey = '_type';